<template>
    <div class="home view">
        <h1>Welkom, {{ this.status.userName }}</h1>
        <div class="home__wrapper">
            <div class="home__user">
                <div class="home__user__img">
                    <img :src="status.userImage" alt="">
                </div>
                <div class="home__user__content">
                    <h2>{{ this.status.userName }}</h2>
                    <p>{{ this.status.userCompany }} | <a :href="webadres" class="link" target="_blank">Website</a></p>                
                    <br>
                    <router-link to="/settings" class="button_2">Account instellingen</router-link>
                </div>
            </div>
            <div class="home__actions">
                <h2>Snelle acties</h2>
                <div class="home__actions__list">
                    <p v-if="settings.projects != 'false'" @click="addProject" class="home__actions__list__button">Project toevoegen</p>
                    <p v-if="settings.nieuws != 'false'" @click="addNieuws" class="home__actions__list__button">Nieuwsartikel toevoegen</p>
                    <p v-if="settings.vacatures != 'false'" @click="addVacature" class="home__actions__list__button">Vacature toevoegen</p>
                    <p v-if="settings.openingsuren != 'false'" @click="editOpen" class="home__actions__list__button">Openingsuren bewerken</p>
                </div>
            </div>
        </div>
        <div class="home__projecten" v-if="appSettings.projects == 'true'">
            <div class="home__projecten__header">
                <h2>Recente Projecten</h2>
                <p @click="goToProjects" class="button_2">Alle projecten</p>
            </div>
            <br>
            <div class="home__projecten__cards" v-if="projects.length > 0">
                <ProjectCard 
                    v-for="project in projects" 
                    :key="project"
                    :titel="project.titel"
                    :img="project.img"
                    :projectID="project.id"
                    :home="true"
                />        
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import ProjectCard from "../components/pages/_templates/cards/ProjectCard.vue";
export default {
    inject:["status", "user", 'appSettings'],
    components:{
        ProjectCard
    },      
    data(){
        return{
            webadres: this.appSettings.website,
            projects: [],
            settings: this.appSettings
        }
    },
    created(){
        this.getData()
    },
    methods:{
        addProject(){
            this.status.pagesPage = "projects"
            this.$router.push('/pages?page=projects&new=true');
        },
        addNieuws(){
            this.status.pagesPage = "nieuws"
            this.$router.push('/pages?page=nieuws&new=true');
        },
        addVacature(){
            this.status.pagesPage = "vacature"
            this.$router.push('/pages?page=vacature&new=true');
        },
        editOpen(){
            sessionStorage.DevPage = "openingsuren"
            this.$router.push('/pages');
        },
        goToProjects(){
            sessionStorage.DevPage = "projects";
            this.$router.push("/pages");
        },  
        async getData(){
            let data;
            await axios.get(this.status.api + '/get/projects.php',{ 
                params:{ 
                    userKey: this.status.userKey,
                    userMail: this.status.userMail,
                    userPass: this.status.userPass,
                    db: this.status.db,
                }
                }).then(function(response){
                        data = response.data;
                }).catch(function(error){ 
                    console.log(error);
            });
            if(data.length >= 0){
                this.projects.push(data[0]);
            }
            if(data.length > 1){
                this.projects.push(data[1]);
            }
            if(data.length > 2){
                this.projects.push(data[2]);
            }
        }
    },
    watch:{
        user: {
        handler(x){
            if(x.status){
                this.getData();
            }
        },
        deep: true
        },
    }
}
</script>